/**
 * A SIDEBAR COUNT IS A GREY NUMBER AT THE RIGHT OF ITS ROW, WITH NO CAPSULE (redesign register
 * R-S2 and L2; the variants page: "Counts are grey numbers at the right"; support:
 * https://support.apple.com/guide/mail/create-or-delete-mailboxes-mlhlp1021/mac shows Mail's
 * sidebar with grey counts at the right of its rows). It replaced the accent tag the rows carried.
 *
 * Nothing at zero and nothing while the number is not known yet: a "0" is noise that trains
 * people to ignore the count, and a number that is not true yet is worse. The number is part of
 * the row's name, so a screen reader reads "Clients 9" as the row says it.
 */
export function NavCount({ value }: { readonly value: number | null }) {
  if (value === null || value <= 0) return null;
  return <span className="shrink-0 tabular-nums text-ink-muted">{value}</span>;
}
